const checkResolution = (query) => {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if (document.querySelector(`.var .visible-${value}`).offsetParent != null) {
            active = true;
        }
    }
    return active;
};

const checkIphone = () => {
    return (
        ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
            navigator.platform
        ) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
};

const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
};

const getCssVar = (name) => {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
};

export { checkResolution, checkIphone, getScrollbarWidth, getCssVar };
